import request from "@/common/request.js";

export function listUser(data) {
  return request({
    url: "/system/user/publicList",
    method: "post",
    params: data,
  });
}
